// extracted by mini-css-extract-plugin
export default {"actions":"WordDetails_actions__BURQP","options":"WordDetails_options__NyKlg","creator":"WordDetails_creator__mjfHE"};